import React, { useState } from 'react'
import Plane from './Plane'
import Walls from './Walls'
import img from '../Assets/15.png'

const Space5 = ({ wallData }) => {

    const useImgSize = useState({
        width: 0,
        height: 0,
        aspectRatio: 0
    })

    return (
        <>
            <Plane useImgSize={useImgSize} sceneImg={img} sceneSize={[192.5583, 145.095]} />
            <Walls useImgSize={useImgSize} wallData={wallData} />
        </>
    )
}

export default Space5
